/*eslint no-console:0*/
export default function log(...args) {
  if (undefined) console.log(...args);
}